<h2 mat-dialog-title>{{ isEditMode ? 'Edytuj pozycję' : 'Dodaj pozycję' }}</h2>

<mat-dialog-content>
	<form [formGroup]="form" class="position-form">
		<div class="position-form__toolbar">
			<button type="button" mat-raised-button (click)="addPayer()">Dodaj wpłacającego</button>
		</div>

		<div class="row g-3">
			<div class="col-md-6">
				<mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
					<mat-label>Numer rezerwacji</mat-label>
					<input
						type="text"
						matInput
						required
						formControlName="tableId"
						[matAutocomplete]="reservationAuto"
					/>
					@if ((form.controls.tableId.touched || submitted) && form.controls.tableId.errors?.required) {
						<mat-error>Uzupełnij numer rezerwacji</mat-error>
					}
					<mat-autocomplete #reservationAuto="matAutocomplete" [displayWith]="displayReservation.bind(this)">
						@for (item of reservationObj; track item.id) {
							<mat-option [value]="item.id">
								{{ item.id }} | {{ item.ownerUser?.firstName }} {{ item.ownerUser?.lastName }}
							</mat-option>
						}
					</mat-autocomplete>
				</mat-form-field>
			</div>

			<div class="col-md-6">
				<mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
					<mat-label>Kto wpłaca</mat-label>
					<input type="text" matInput required formControlName="userData" [matAutocomplete]="userAuto" />
					@if ((form.controls.userData.touched || submitted) && form.controls.userData.errors?.required) {
						<mat-error>Uzupełnij wpłacającego</mat-error>
					}
					<mat-autocomplete #userAuto="matAutocomplete" [displayWith]="displayUserProfile.bind(this)">
						@for (item of filteredUsers; track item.id) {
							<mat-option [value]="item.id">{{ item.firstName }} {{ item.lastName }}</mat-option>
						}
					</mat-autocomplete>
				</mat-form-field>
			</div>

			<div class="col-md-4">
				<mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
					<mat-label>Kwota</mat-label>
					<input matInput type="number" required formControlName="amount" />
					@if ((form.controls.amount.touched || submitted) && form.controls.amount.errors?.required) {
						<mat-error>Uzupełnij kwotę płatności</mat-error>
					}
				</mat-form-field>
			</div>

			<div class="col-md-4">
				<mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
					<mat-label>Data wpłaty</mat-label>
					<input matInput formControlName="payment" [matDatepicker]="paymentPicker" />
					@if ((form.controls.payment.touched || submitted) && form.controls.payment.errors?.required) {
						<mat-error>Uzupełnij datę wpłaty</mat-error>
					}
					<mat-datepicker-toggle matSuffix [for]="paymentPicker"></mat-datepicker-toggle>
					<mat-datepicker #paymentPicker></mat-datepicker>
				</mat-form-field>
			</div>

			<div class="col-md-4">
				<mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
					<mat-label>Konto klienta</mat-label>
					<input matInput formControlName="bankAccountIncoming" />
					@if (
						(form.controls.bankAccountIncoming.touched || submitted) &&
						form.controls.bankAccountIncoming.errors?.required
					) {
						<mat-error>Uzupełnij konto klienta</mat-error>
					}
				</mat-form-field>
			</div>

			<div class="col-md-6">
				<mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
					<mat-label>Nr faktury</mat-label>
					<input matInput formControlName="invoiceNumber" />
				</mat-form-field>
			</div>

			<div class="col-md-6">
				<mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
					<mat-label>Uwagi</mat-label>
					<input matInput formControlName="note" />
				</mat-form-field>
			</div>
		</div>
	</form>
</mat-dialog-content>

<mat-dialog-actions align="end">
	<button type="button" mat-raised-button (click)="cancel()">Anuluj</button>
	<button type="button" mat-raised-button color="primary" (click)="save()">
		{{ isEditMode ? 'Zapisz' : 'Dodaj' }}
	</button>
</mat-dialog-actions>
